import axios from 'axios';

const state = {
    all: []
};

const mutations = {
    load(state, courses){
        while(state.all.length){
            state.all.pop();
        }

        courses.sort((a, b) => {
            return a.title.localeCompare(b.title);
        });

        for(const course of courses){
            state.all.push(course);
        }
    },
    clear(state){
        this.all = [];
    }
};

const actions = {
    load({commit, dispatch}){
        commit('clear');

        return axios.get('/courses/sync')
        .then(response => commit('load', response.$data))
        .catch(error => console.log(error));
    },
    clear({commit}){
        commit('clear');
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
